import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EnumLike } from '@bbkAdminUtils/utility-types';
import { type FulfillmentStatus } from '@bbkAdminRedux/rtkq/reports.slice';

export const FulfillmentStatusPill: React.FC<{
  status: EnumLike<typeof FulfillmentStatus>;
}> = ({ status }) => (
  <div
    className={cs(
      'tw-mr-2 tw-h-3 tw-w-3 tw-rounded-full tw-bg-cbrprimary-500',
      {
        'tw-bg-cbrsuccess-300': status === 'COMPLETED',
        'tw-bg-cbrdanger-300': status === 'FAILED',
      }
    )}
  />
);
